import React, { memo, ReactElement, useCallback, useState } from 'react'
import ReactSelect from 'react-select'
import { FieldEventTypes } from '../../Form'

type OptionTypes = {
  value: string
  label: string
}

type SelectPropTypes = {
  id: string
  name: string
  placeholder: string
  error?: string
  half?: boolean
  options: OptionTypes[]
  onChange?(event: FieldEventTypes): void
  onBlur?(event: FieldEventTypes): void
  defaultValue?: OptionTypes
}

const Select = ({
  id,
  name,
  placeholder,
  error,
  half,
  options,
  onChange,
  onBlur,
  defaultValue,
}: SelectPropTypes): ReactElement => {
  const [value, setValue] = useState<OptionTypes | null>(defaultValue || null)
  const [isFocused, setIsFocused] = useState<boolean>(false)

  const handleChange = useCallback(
    (selectedValue) => {
      setValue(selectedValue)
      const event = {
        currentTarget: {
          name,
          value: selectedValue.value,
        },
      }

      if (onChange) {
        onChange(event)
      }

      if (onBlur) {
        onBlur(event)
      }
    },
    [name, onChange, onBlur],
  )

  return (
    <div className={`form-field-container${half ? ' half' : ''}`}>
      <div
        className={`form-field${error ? ' has-error' : ''}${
          !value ? ' empty-field' : ''
        }${isFocused ? ' is-focused' : ''}`}
      >
        <ReactSelect
          inputId={id}
          name={name}
          placeholder={placeholder}
          onChange={handleChange}
          onFocus={(): void => setIsFocused(true)}
          onBlur={(): void => setIsFocused(false)}
          options={options}
          isSearchable
          defaultValue={value}
        />
        <label htmlFor={id}>{placeholder}</label>
      </div>
      <p className="form-field-error">{error}</p>
    </div>
  )
}

export default memo(Select)
